export default __webpack_public_path__ + "static/media/blog-img216.a40e39fb.jpg";